import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "gallery-slider-wrap" }
const _hoisted_2 = { class: "gallery-slider" }
const _hoisted_3 = { class: "gallery-slider-thumbs" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "thumb-counter" }
const _hoisted_6 = {
  key: 1,
  class: "gallery-slider-wrap"
}
const _hoisted_7 = { class: "gallery-slider" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdDetailGalleryTopButtons = _resolveComponent("AdDetailGalleryTopButtons")!
  const _component_AdImage = _resolveComponent("AdImage")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_LightBox = _resolveComponent("LightBox")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.hasImages)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                class: "slider-prev",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onPrevious && _ctx.onPrevious(...args)))
              }),
              _createElementVNode("div", {
                class: "slider-next",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onNext && _ctx.onNext(...args)))
              }),
              _createVNode(_component_AdDetailGalleryTopButtons, {
                showStreetView: _ctx.showStreetView,
                virtualTourLink: _ctx.virtualTourLink,
                videoLink: _ctx.videoLink,
                onNavigate: _ctx.onNavigate,
                onStreetview: _ctx.onStreetView,
                onVirtualtour: _ctx.onVirtualTour,
                onVideo: _ctx.onVideo
              }, null, 8, ["showStreetView", "virtualTourLink", "videoLink", "onNavigate", "onStreetview", "onVirtualtour", "onVideo"]),
              _createVNode(_component_swiper, {
                ref: "mySwiper",
                onSwiper: _ctx.onSwiper,
                loop: true,
                "auto-height": true
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allImages, (item, index) => {
                    return (_openBlock(), _createBlock(_component_swiper_slide, { key: index }, {
                      default: _withCtx(() => [
                        _createVNode(_component_AdImage, {
                          file: String(item.image),
                          adGuid: item.adGuid,
                          estateType: _ctx.estateType,
                          estateSubType: _ctx.estateSubType,
                          width: _ctx.imageWidth,
                          height: _ctx.imageHeight,
                          hrmode: "max",
                          backgroundImage: false,
                          alt: _ctx.alt + '_' + (index + 1)
                        }, null, 8, ["file", "adGuid", "estateType", "estateSubType", "width", "height", "alt"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["onSwiper"])
            ])
          ]),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.thumbs, (image, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: image,
                class: "slider-thumb",
                onClick: ($event: any) => (_ctx.onSelect(index + 1))
              }, [
                (_ctx.allImages.length > _ctx.maxCount && index === _ctx.maxCount - 1)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("span", null, _toDisplayString(index + 1) + " / " + _toDisplayString(_ctx.allImages.length), 1)
                      ]),
                      _createVNode(_component_AdImage, {
                        file: String(image.image),
                        adGuid: image.adGuid,
                        estateType: _ctx.estateType,
                        estateSubType: _ctx.estateSubType,
                        width: 190,
                        height: 140,
                        backgroundImage: false,
                        alt: _ctx.alt + '_' + (index + 2)
                      }, null, 8, ["file", "adGuid", "estateType", "estateSubType", "alt"])
                    ], 64))
                  : (_openBlock(), _createBlock(_component_AdImage, {
                      key: 1,
                      file: String(image.image),
                      adGuid: image.adGuid,
                      estateType: _ctx.estateType,
                      estateSubType: _ctx.estateSubType,
                      width: 150,
                      height: 140,
                      backgroundImage: false,
                      alt: _ctx.alt + '_' + (index + 2)
                    }, null, 8, ["file", "adGuid", "estateType", "estateSubType", "alt"]))
              ], 8, _hoisted_4))
            }), 128))
          ]),
          _createVNode(_component_LightBox, {
            ref: "lightbox",
            media: _ctx.media,
            "show-light-box": false
          }, null, 8, ["media"])
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_AdDetailGalleryTopButtons, {
              showStreetView: _ctx.showStreetView,
              virtualTourLink: _ctx.virtualTourLink,
              videoLink: _ctx.videoLink,
              onNavigate: _ctx.onNavigate,
              onStreetview: _ctx.onStreetView,
              onVirtualtour: _ctx.onVirtualTour,
              onVideo: _ctx.onVideo
            }, null, 8, ["showStreetView", "virtualTourLink", "videoLink", "onNavigate", "onStreetview", "onVirtualtour", "onVideo"]),
            _createVNode(_component_AdImage, {
              file: null,
              estateType: _ctx.estateType,
              estateSubType: _ctx.estateSubType,
              width: 1100,
              height: 675,
              hrmode: "max",
              backgroundImage: false
            }, null, 8, ["estateType", "estateSubType"])
          ])
        ]))
  ]))
}